import { Box, Fab, Typography, ThemeProvider } from "@mui/material";
import React from "react";
import ImgHelper from "@/components/common/ImgHelper";
import { useAppTheme } from "@/theme";
import useIntercom from "@/hooks/useIntercom";
import { useAppPathname } from "@/routing/navigation";
import { useSourceUrlState } from "@/hooks/urlState";
import useIsFlagVariantTest from "@/hooks/useIsFlagVariantTest";
import { aboveBottomBanners } from "@/components/banners/placements/bottomInsets";

const hideOnPaths = [
  "/subscription/customize",
  "/subscription/choose-plan",
  "/extension-captcha-challenge",
  "/calculator",
  "/register",
  // The OAuth consent screen is a standalone Webshare page with nothing else on it.
  "/oauth",
];

//Used by intercom for openind onboarding checklist using intercom tooltips
export default function OnboardingChecklistFAB() {
  const [source] = useSourceUrlState();
  const isIframeSource = source === "browse_plan_iframe";
  const { showSpace } = useIntercom();
  const appTheme = useAppTheme("light");
  const pathname = useAppPathname();
  const isExpressCheckoutTest = useIsFlagVariantTest(
    "express-checkout-experiment"
  );
  const hideForExpressCheckout =
    pathname === "/express-checkout" && isExpressCheckoutTest;

  if (
    hideOnPaths.some((path) => pathname?.startsWith(path)) ||
    isIframeSource ||
    hideForExpressCheckout
  )
    return null;

  return (
    <ThemeProvider theme={appTheme}>
      <Fab
        id="get-started-button"
        data-testid="get-started-button"
        variant="extended"
        size="small"
        color={"primary"}
        sx={{ position: "fixed", bottom: aboveBottomBanners(8), right: 8 }}
        onClick={() => {
          showSpace("tasks");
        }}
      >
        <Box width={30} marginRight={1}>
          <ImgHelper
            alt="webshare-logo"
            src="/companylogos/webshare-white-logo-sm.png"
            width={30}
            height={30}
          />
        </Box>
        <Typography
          color="white"
          fontWeight="bold"
          fontSize="small"
          variant="body1"
          textTransform={"none"}
        >
          Get Started
        </Typography>
      </Fab>
    </ThemeProvider>
  );
}
